module.exports = __webpack_public_path__ + "img/article_2_5.8a6b280d.png";